import React from 'react';
import classNames from 'classnames';
import Button, { ButtonProps } from './Button';

const SecondaryButton = React.forwardRef<HTMLButtonElement, ButtonProps>(({ className, children, ...rest }, ref) => (
  <Button ref={ref} className={classNames(className, 'secondary')} {...rest}>
    {children}
  </Button>
));

export default SecondaryButton;
